export const REQUIRED_CANDIDATE_DOCUMENTS_CONTAINER_ID = 1;
export const CAMPAIGN_DOCUMENTS_CONTAINER_ID = 2;
